import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { VrcDatepickerComponent } from './vrc-datepicker.component';
import { VrcCalendarComponent } from './vrc-calendar/vrc-calendar.component';

import { VrCommonModule } from '../../vr-common.module';
import { VrcCalendarEventsService } from './service/vrc-calendar-events.service';

const exports = [VrcDatepickerComponent];

@NgModule({
  declarations: [VrcCalendarComponent, ...exports],
  exports,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    VrCommonModule,
    HttpClientModule
  ],
  providers: [VrcCalendarEventsService]
})
export class VrcDatepickerModule { }
